import React, { FC } from 'react';
import { translate } from '@/translation/translate.ts';
import { SelectFieldOption } from '@/eventConfig/types.ts';

export interface OptionProps {
  selectOption: SelectFieldOption;
  value: string;
}

export const Option: FC<OptionProps> = ({ selectOption, value }) => {
  const { label } = selectOption;
  return (
    <option value={selectOption.value} disabled={!String(selectOption.value) && !!value}>
      {translate(label)}
    </option>
  );
};
